export default "__VITE_ASSET__Bl6B0aKr__"